class MobileSecondaryMenu extends MenuDrawer {
    constructor() {
      super();

    }

    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest('.has-submenu');
      const isOpen = detailsElement.hasAttribute('open');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');


      if (document.querySelector('header-drawer') != null) {
        if (document.querySelector('header-drawer').querySelector('details[open]') != null) {
          document.querySelector('header-drawer').querySelector('summary').click();
        }
      }
      console.log(isOpen)
      isOpen ? this.closeMenuDrawer(event, summaryElement) :  this.openMenuDrawer(summaryElement, detailsElement);
      
  
      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    }

    closeOtherMenu(summaryElement, detailsElement){
        const parentMenuElement = detailsElement.closest('.list-menu');
        parentMenuElement && parentMenuElement.querySelectorAll('details').forEach((details) => {
          if (!details.contains(summaryElement)) {
            details.removeAttribute('open');
            details.classList.remove('menu-opening');
            details.querySelector('summary').setAttribute('aria-expanded', false);
            removeTrapFocus(details.querySelector('summary'));
            this.closeAnimation(details);
          }
        });
        
    }

    openMenuDrawer(summaryElement, detailsElement) {
      this.closeOtherMenu(summaryElement, detailsElement)
      this.header = this.header || document.querySelector('.section-header');
      this.borderOffset =
        this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
      this.header.classList.add('menu-open');
    
      setTimeout(() => {
        summaryElement.parentNode.classList.add('menu-opening');
      }, 100);
    
      summaryElement.setAttribute('aria-expanded', true);
      window.addEventListener('resize', this.onResize);
      trapFocus(summaryElement.parentNode, summaryElement);
      document.body.classList.add(`overflow-hidden`);
    }

    closeMenuDrawer(event, elementToFocus) {
      if (event === undefined) return;
      const detailsElement = elementToFocus.parentNode;
    
      detailsElement.classList.remove('menu-opening');
      detailsElement.querySelectorAll('details').forEach((details) => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      detailsElement.querySelectorAll('.submenu-open').forEach((submenu) => {
        submenu.classList.remove('submenu-open');
      });
      document.body.classList.remove(`overflow-hidden`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(detailsElement);

      if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);

      this.header.classList.remove('menu-open');
      window.removeEventListener('resize', this.onResize);
    }

  
    onResize = () => {
      this.header &&
        document.documentElement.style.setProperty(
          '--header-bottom-position',
          `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
        );
      document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    };
  }
  
  customElements.define('mobile-secondary-menu', MobileSecondaryMenu);
  
  class VerticalSliderComponent extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('[id^="Slider-"]');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.enableSliderLooping = false;
      this.currentPageElement = this.querySelector('.slider-counter--current');
      this.pageTotalElement = this.querySelector('.slider-counter--total');
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');
  
      if (!this.slider || !this.nextButton) return;
  
      this.initPages();
      const resizeObserver = new ResizeObserver((entries) => this.initPages());
      resizeObserver.observe(this.slider);
  
      this.slider.addEventListener('scroll', this.update.bind(this));
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }
  
    initPages() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetTop - this.sliderItemsToShow[0].offsetTop;
      this.slidesPerPage = Math.floor(
        (this.slider.clientWidth - this.sliderItemsToShow[0].offsetTop) / this.sliderItemOffset
      );
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
      this.update();
    }
  
    resetPages() {
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.initPages();
    }
  
    update() {
      // Temporarily prevents unneeded updates resulting from variant changes
      // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
      if (!this.slider || !this.nextButton) return;
  
      const previousPage = this.currentPage;
      this.currentPage = Math.round(this.slider.scrollTop / this.sliderItemOffset) + 1;
  
      if (this.currentPageElement && this.pageTotalElement) {
        this.currentPageElement.textContent = this.currentPage;
        this.pageTotalElement.textContent = this.totalPages;
      }
  
      if (this.currentPage != previousPage) {
        this.dispatchEvent(
          new CustomEvent('slideChanged', {
            detail: {
              currentPage: this.currentPage,
              currentElement: this.sliderItemsToShow[this.currentPage - 1],
            },
          })
        );
      }
  
      if (this.enableSliderLooping) return;
  
      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollTop === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }
  
      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
  
    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollTop - offset;
      return element.offsetTop + element.clientWidth <= lastVisibleSlide && element.offsetTop >= this.slider.scrollTop;
    }
  
    onButtonClick(event) {
      event.preventDefault();
      const step = event.currentTarget.dataset.step || 1;
      this.slideScrollPosition =
        event.currentTarget.name === 'next'
          ? this.slider.scrollTop + step * this.sliderItemOffset
          : this.slider.scrollTop - step * this.sliderItemOffset;
      this.setSlidePosition(this.slideScrollPosition);
    }
  
    setSlidePosition(position) {
      this.slider.scrollTo({
        top: position,
      });
    }
  }
  
  customElements.define('vertical-slider-component', VerticalSliderComponent);

  class StockAvailability extends HTMLElement {
    constructor() {
      super();

      this.variantId = this.getAttribute("data-variant");
    }

    variantIdChangedUnsubscriber = undefined;

    connectedCallback() {
      this.getStock();
      this.variantIdChangedUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        this.variantId = event.data.variant.id;
        this.getStock();
        this.setAttribute("data-variant", this.variantId);
        if (this.querySelector('.variant-title') != null){
          this.querySelector('.variant-title').textContent = event.data.variant.title;
        }
      });
    }

    getStock() {
      let payload = {
        "variant_id": this.variantId
      };

      fetch(' https://dev.cultivated.agency/orbit/check_store_availability.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
      })
      .then(response => {
          return response.json();
      })
      .then(data => {
        let dataContent = '';
        let inventoryStatus = '';

        if (data.length > 0) {
          data.forEach(location => {
            if (location.Quantity >= 3) {
              inventoryStatus = `<span class="location-instock">${window.variantStrings.stock_available}</span>`
            } else if (location.Quantity >= 1) {
              inventoryStatus = `<span class="location-lowstock">${window.variantStrings.stock_low}</span>`
            } else {
              inventoryStatus = `<span class="location-nostock">${window.variantStrings.stock_unavailable}</span>`
            }

            dataContent += `<div class="location-item">`;
            dataContent += `<div class="location-item-info">`;
            dataContent += `<a href="${location.PhoneNumber}" target="_blank"><span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M280 0C408.1 0 512 103.9 512 232c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-72c0-13.3 10.7-24 24-24c75.1 0 136 60.9 136 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88c-13.3 0-24-10.7-24-24zM117.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7L345 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512C200.6 512 0 311.4 0 64C0 46 12.1 30.2 29.5 25.4l88-24z"/></svg></span></a>`;
            dataContent += `<a href="${location.StorePage}" target="_blank"><span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"/></svg></span></a>`;
            dataContent += `</div>`;
            dataContent += `<span>${location.Location}</span>`;
            dataContent += inventoryStatus;
            dataContent += `</div>`;
          })

          this.querySelector('.stock-availability-inner').innerHTML = dataContent;
        } else {
          const modalId = this.closest('modal-dialog').getAttribute('id');
          document.querySelector('modal-opener[data-modal="#'+ modalId +'"]').style.display = 'none';
        }
      });
    }

  }

  customElements.define('stock-availability', StockAvailability);


window.addEventListener("scroll", function() {
  const header = document.querySelector(".a_commercialPage sticky-header");
  if(header) {
    header.classList.toggle("scrolled", window.scrollY > 50);
  }
});

document.querySelectorAll('.a_caseStudyCard').forEach(function(card){

  const main = card.querySelector('.a_caseStudyMainSlider');
  const thumbs = card.querySelector('.a_caseStudyThumbSlider');

  if(main && thumbs){

    const thumbSlider = new Splide(thumbs,{
      fixedWidth:70,
      fixedHeight:70,
      gap:10,
      rewind:false,
      pagination:false,
      isNavigation:true,
      focus:'start',
      arrows:false
    });

    const mainSlider = new Splide(main,{
      type:'fade',
      pagination:true,
      arrows:false
    });

    mainSlider.sync(thumbSlider);

    thumbSlider.mount();
    mainSlider.mount();

  }
});


document.addEventListener('DOMContentLoaded', function () {
  const drawers = document.querySelectorAll('[data-accordion-drawer]');

  drawers.forEach(function (drawer) {
    // Move drawer directly under body
    document.body.appendChild(drawer);
  });

  const triggers = document.querySelectorAll(
    '[data-accordion-drawer-trigger]'
  );

  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      const drawerId = this.getAttribute('data-drawer-id');
      const drawer = document.getElementById(drawerId);

      if (!drawer) return;

      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');

      document.body.classList.add('accordion-drawer-open');
    });
  });

  document.addEventListener('click', function (event) {
    const closeButton = event.target.closest('[data-drawer-close]');

    if (!closeButton) return;

    const drawer = closeButton.closest('[data-accordion-drawer]');

    if (!drawer) return;

    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');

    document.body.classList.remove('accordion-drawer-open');
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    const drawer = document.querySelector(
      '[data-accordion-drawer].is-open'
    );

    if (!drawer) return;

    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');

    document.body.classList.remove('accordion-drawer-open');
  });
});